module.exports = __webpack_public_path__ + "img/hopper.8b12db98.png";